// extracted by mini-css-extract-plugin
export default {"toolbar":"HeaderToolbar_toolbar__w9nHm","shareButton":"HeaderToolbar_shareButton__tCqNR","toolbarSearch":"HeaderToolbar_toolbarSearch__0n8J1"};